export default __webpack_public_path__ + "static/media/earth2-91.7cda161a.png";